import React, { useState, useEffect } from 'react';
import { FaBars, FaChevronRight, FaClock, FaDownload, FaEye, FaGraduationCap, FaTimes } from 'react-icons/fa';


const CourseSectionPage = () => {
  // Categories and their respective courses with improved icons
  const courseCategories = [
    {
      id: 'tech-training',
      name: 'Software Training Programs',
      icon: "",
      courses: [
        { id: 'ux-ui', name: 'UX/UI Design', description: 'Learn user experience and interface design', duration: '3 months', level: 'Beginner to Advanced', popular: true },
        { id: 'software-dev', name: 'Software Development', description: 'Master software development fundamentals', duration: '6 months', level: 'All Levels', popular: true },
        { id: 'blockchain', name: 'Blockchain Development', description: 'Develop decentralized applications', duration: '4 months', level: 'Intermediate', popular: false },
        { id: 'mobile-app', name: 'Mobile App Development', description: 'Create iOS and Android applications', duration: '5 months', level: 'Intermediate', popular: true },
        { id: 'web-dev', name: 'Web Development', description: 'Build modern web applications', duration: '4 months', level: 'Beginner to Advanced', popular: true },
        { id: 'full-stack', name: 'Full Stack Development', description: 'Master both frontend and backend', duration: '8 months', level: 'Advanced', popular: true },
        { id: 'java-dev', name: 'Full Stack Java', description: 'Java-based full stack development', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'web3', name: 'Web 3.0/4.0', description: 'Next generation web technologies', duration: '5 months', level: 'Advanced', popular: false }
      ]
    },
    {
      id: 'ai-ml',
      name: 'AI & Data Science',
      icon: "",
      courses: [
        { id: 'ai-ml-eng', name: 'AI & ML Engineering', description: 'Build intelligent systems with ML', duration: '6 months', level: 'Intermediate', popular: true },
        { id: 'prompt-eng', name: 'Prompt Engineering', description: 'Master LLM prompt creation', duration: '2 months', level: 'Beginner to Advanced', popular: true },
        { id: 'data-analyst', name: 'Data Analyst', description: 'Analyze and visualize data', duration: '4 months', level: 'Beginner', popular: true },
        { id: 'business-analyst', name: 'Business Analyst', description: 'Data-driven business decisions', duration: '3 months', level: 'Intermediate', popular: false },
        { id: 'big-data', name: 'Big Data Engineering', description: 'Process large datasets efficiently', duration: '5 months', level: 'Advanced', popular: true },
        { id: 'deep-learning', name: 'Deep Learning', description: 'Neural networks and advanced AI', duration: '6 months', level: 'Advanced', popular: false },
        { id: 'nlp', name: 'Natural Language Processing', description: 'Text analysis and language models', duration: '4 months', level: 'Intermediate', popular: false },
        { id: 'computer-vision', name: 'Computer Vision', description: 'Image recognition and processing', duration: '5 months', level: 'Advanced', popular: true }
      ]
    },
    {
      id: 'cloud-computing',
      name: 'Cloud & DevOps',
      icon:"",
      courses: [
        { id: 'cloud-computing', name: 'Cloud Computing', description: 'Master cloud infrastructure', duration: '4 months', level: 'Intermediate', popular: true },
        { id: 'cloud-architect', name: 'Cloud Architect', description: 'Design cloud solutions', duration: '6 months', level: 'Advanced', popular: true },
        { id: 'cloud-engineer', name: 'Cloud Engineer', description: 'Implement cloud infrastructure', duration: '5 months', level: 'Intermediate', popular: false },
        { id: 'devops', name: 'DevOps Engineer', description: 'Streamline development operations', duration: '4 months', level: 'Intermediate to Advanced', popular: true },
        { id: 'aws', name: 'AWS Certification', description: 'Amazon Web Services training', duration: '3 months', level: 'Beginner to Advanced', popular: true },
        { id: 'azure', name: 'Azure Certification', description: 'Microsoft Azure cloud platform', duration: '3 months', level: 'Beginner to Advanced', popular: false },
        { id: 'gcp', name: 'Google Cloud Platform', description: 'GCP services and solutions', duration: '3 months', level: 'Intermediate', popular: false },
        { id: 'kubernetes', name: 'Kubernetes & Docker', description: 'Container orchestration', duration: '2 months', level: 'Intermediate', popular: true }
      ]
    },
    {
      id: 'emerging-tech',
      name: 'Emerging Technologies',
      icon: "",
      courses: [
        { id: 'quantum', name: 'Quantum Computing', description: 'Learn quantum programming fundamentals', duration: '6 months', level: 'Advanced', popular: false },
        { id: 'robotics', name: 'Robotics', description: 'Build and program robots', duration: '5 months', level: 'Intermediate', popular: true },
        { id: 'iot', name: 'Internet of Things', description: 'Connect and manage IoT devices', duration: '4 months', level: 'Intermediate', popular: true },
        { id: 'cybersecurity', name: 'Cybersecurity', description: 'Protect systems and data', duration: '6 months', level: 'Beginner to Advanced', popular: true },
        { id: 'ar-vr', name: 'AR/VR Development', description: 'Augmented and virtual reality', duration: '5 months', level: 'Intermediate', popular: true },
        { id: 'edge-computing', name: 'Edge Computing', description: 'Process data closer to source', duration: '3 months', level: 'Advanced', popular: false },
        { id: 'digital-twin', name: 'Digital Twin Technology', description: 'Virtual replicas of physical systems', duration: '4 months', level: 'Advanced', popular: false },
        { id: '5g-tech', name: '5G Technologies', description: 'Next-gen communication systems', duration: '3 months', level: 'Intermediate', popular: true }
      ]
    },
    {
      id: 'energy-sector',
      name: 'Energy & Industry',
      icon: "",
      courses: [
        { id: 'oil-gas', name: 'Oil & Gas Engineering', description: 'Petroleum engineering fundamentals', duration: '8 months', level: 'Advanced', popular: true },
        { id: 'mining', name: 'Mining Engineering', description: 'Modern mining techniques', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'energy-mgmt', name: 'Energy Management', description: 'Optimize energy resources', duration: '4 months', level: 'Intermediate', popular: true },
        { id: 'renewable', name: 'Renewable Energy', description: 'Solar, wind, and alternative energy', duration: '5 months', level: 'Beginner to Advanced', popular: true },
        { id: 'smart-grid', name: 'Smart Grid Technology', description: 'Modern electrical grid systems', duration: '6 months', level: 'Advanced', popular: false },
        { id: 'energy-analytics', name: 'Energy Analytics', description: 'Data analysis for energy sector', duration: '3 months', level: 'Intermediate', popular: false },
        { id: 'sustainability', name: 'Sustainable Engineering', description: 'Green engineering practices', duration: '4 months', level: 'Intermediate', popular: true },
        { id: 'industrial-auto', name: 'Industrial Automation', description: 'Factory and process automation', duration: '6 months', level: 'Advanced', popular: true }
      ]
    },
    {
      id: 'iit-jee',
      name: 'IIT JEE Preparation',
      icon: "",
      courses: [
        { id: 'jee-mains', name: 'JEE Mains', description: 'Complete preparation for JEE Mains', duration: '12 months', level: 'Intermediate to Advanced', popular: true },
        { id: 'jee-advanced', name: 'JEE Advanced', description: 'Advanced preparation for IITs', duration: '12 months', level: 'Advanced', popular: true },
        { id: 'jee-foundation', name: 'Foundation Course', description: 'Early preparation for Classes 9-10', duration: '24 months', level: 'Beginner', popular: true },
        { id: 'jee-test-series', name: 'Test Series', description: 'Practice with mock tests', duration: '3 months', level: 'Intermediate to Advanced', popular: true },
        { id: 'jee-physics', name: 'Physics for JEE', description: 'Focus on physics concepts', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'jee-chemistry', name: 'Chemistry for JEE', description: 'Master chemistry fundamentals', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'jee-maths', name: 'Mathematics for JEE', description: 'Advanced mathematical concepts', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'jee-crash', name: 'Crash Course', description: 'Last-minute preparation', duration: '2 months', level: 'Advanced', popular: true }
      ]
    },
    {
      id: 'neet',
      name: 'NEET Preparation',
      icon: "",
      courses: [
        { id: 'neet-ug', name: 'NEET UG', description: 'Undergraduate medical entrance', duration: '12 months', level: 'Intermediate to Advanced', popular: true },
        { id: 'neet-pg', name: 'NEET PG', description: 'Postgraduate medical entrance', duration: '12 months', level: 'Advanced', popular: true },
        { id: 'fmge', name: 'FMGE', description: 'Foreign Medical Graduate Examination', duration: '6 months', level: 'Advanced', popular: false },
        { id: 'neet-foreign', name: 'Foreign Medical Admissions', description: 'Study medicine abroad', duration: '6 months', level: 'Intermediate', popular: true },
        { id: 'neet-biology', name: 'Biology for NEET', description: 'Focus on biology concepts', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'neet-chemistry', name: 'Chemistry for NEET', description: 'Master chemistry fundamentals', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'neet-physics', name: 'Physics for NEET', description: 'Physics concepts for medical', duration: '6 months', level: 'Intermediate', popular: false },
        { id: 'neet-crash', name: 'Crash Course', description: 'Last-minute preparation', duration: '2 months', level: 'Advanced', popular: true }
      ]
    },
    {
      id: 'iit-jam',
      name: 'IIT JAM Preparation',
      icon: "",
      courses: [
        { id: 'jam-geology', name: 'JAM Geology', description: 'Geology for MSc admission', duration: '6 months', level: 'Advanced', popular: true },
        { id: 'jam-chemistry', name: 'JAM Chemistry', description: 'Chemistry for MSc admission', duration: '6 months', level: 'Advanced', popular: true },
        { id: 'jam-physics', name: 'JAM Physics', description: 'Physics for MSc admission', duration: '6 months', level: 'Advanced', popular: false },
        { id: 'jam-biology', name: 'JAM Biology', description: 'Biology for MSc admission', duration: '6 months', level: 'Advanced', popular: false },
        { id: 'jam-mathematics', name: 'JAM Mathematics', description: 'Mathematics for MSc admission', duration: '6 months', level: 'Advanced', popular: true }
      ]
    },
    {
      id: 'abroad-exams',
      name: 'Abroad Entrance Exams',
      icon: "",
      courses: [
        { id: 'gre', name: 'GRE', description: 'Graduate Record Examination', duration: '3 months', level: 'Intermediate', popular: true },
        { id: 'toefl', name: 'TOEFL', description: 'Test of English as a Foreign Language', duration: '2 months', level: 'Beginner to Advanced', popular: true },
        { id: 'ielts', name: 'IELTS', description: 'International English Language Testing System', duration: '2 months', level: 'Beginner to Advanced', popular: true },
        { id: 'gmat', name: 'GMAT', description: 'Graduate Management Admission Test', duration: '3 months', level: 'Intermediate', popular: true },
        { id: 'sat', name: 'SAT', description: 'Scholastic Assessment Test', duration: '3 months', level: 'Intermediate', popular: false },
        { id: 'pte', name: 'PTE', description: 'Pearson Test of English', duration: '2 months', level: 'Beginner to Advanced', popular: false },
        { id: 'duolingo', name: 'Duolingo English Test', description: 'Online English proficiency test', duration: '1 month', level: 'Beginner to Advanced', popular: true },
        { id: 'cambridge', name: 'Cambridge English', description: 'Cambridge English qualifications', duration: '3 months', level: 'Beginner to Advanced', popular: false }
      ]
    },
    {
      id: 'business',
      name: 'Business & Management',
      icon: "",
      courses: [
        { id: 'mba-prep', name: 'MBA Preparation', description: 'Management entrance exams', duration: '4 months', level: 'Intermediate', popular: true },
        { id: 'finance', name: 'Finance', description: 'Financial management and analysis', duration: '5 months', level: 'Intermediate', popular: true },
        { id: 'marketing', name: 'Marketing', description: 'Digital and traditional marketing', duration: '4 months', level: 'Beginner to Advanced', popular: true },
        { id: 'leadership', name: 'Leadership', description: 'Team and organization leadership', duration: '3 months', level: 'Intermediate to Advanced', popular: false },
        { id: 'project-management', name: 'Project Management', description: 'Managing complex projects', duration: '3 months', level: 'Intermediate', popular: true },
        { id: 'supply-chain', name: 'Supply Chain Management', description: 'Logistics and distribution', duration: '4 months', level: 'Intermediate', popular: false },
        { id: 'entrepreneurship', name: 'Entrepreneurship', description: 'Starting and scaling businesses', duration: '6 months', level: 'Beginner to Advanced', popular: true },
        { id: 'digital-marketing', name: 'Digital Marketing', description: 'Online marketing strategies', duration: '3 months', level: 'Beginner', popular: true }
      ]
    }
  ];

  const [activeCategory, setActiveCategory] = useState(courseCategories[0].id);
  const [isAnimating, setIsAnimating] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');

  // Check window width on mount and resize
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkIsMobile();
    
    // Add event listener
    window.addEventListener('resize', checkIsMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const handleCategoryChange = (categoryId) => {
    setIsAnimating(true);
    setActiveCategory(categoryId);
    setActiveFilter('all');
    
    // Close sidebar on mobile when category is selected
    if (isMobile) {
      setSidebarOpen(false);
    }
    
    // Reset animation after 300ms
    setTimeout(() => {
      setIsAnimating(false);
    }, 300);
  };

  const getFilteredCourses = () => {
    const allCourses = courseCategories.find(category => category.id === activeCategory)?.courses || [];
    
    if (activeFilter === 'all') {
      return allCourses;
    } else if (activeFilter === '3months') {
      return allCourses.filter(course => {
        const duration = parseInt(course.duration);
        return duration <= 3;
      });
    } else if (activeFilter === '6months') {
      return allCourses.filter(course => {
        const duration = parseInt(course.duration);
        return duration > 3 && duration <= 6;
      });
    } else if (activeFilter === '9months') {
      return allCourses.filter(course => {
        const duration = parseInt(course.duration);
        return duration > 6 && duration <= 9;
      });
    } else if (activeFilter === '1year') {
      return allCourses.filter(course => {
        const duration = parseInt(course.duration);
        return duration > 9;
      });
    } else if (activeFilter === 'popular') {
      return allCourses.filter(course => course.popular);
    }
    
    return allCourses;
  };

  const getActiveCategoryName = () => {
    return courseCategories.find(category => category.id === activeCategory)?.name || '';
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (

<div className="my-5 py-5" >
  <h2 className='text-center fw-bold '>Top Courses & Programs Catalogue</h2> <hr/>
 <div className="course-section-wrapper">
      {/* Mobile Menu Button */}
      {isMobile && (
        <button 
          className="mobile-menu-btn"
          onClick={toggleSidebar}
          aria-label={sidebarOpen ? "Close menu" : "Open menu"}
        >
          {sidebarOpen ? <FaTimes /> : <FaBars />}
          <span>Catalog</span>
        </button>
      )}

      <div className="course-section-container">
        {/* Sidebar */}
        <div className={`sidebar ${sidebarOpen || !isMobile ? 'open' : ''}`}>
          <div className="sidebar-header">
            <FaGraduationCap className="sidebar-icon"  size={30}/>
            <h3>Courses Catalogue</h3>
            {isMobile && (
              <button className="close-sidebar" onClick={() => setSidebarOpen(false)}>
                <FaTimes />
              </button>
            )}
          </div>
          <div className="sidebar-links">
            {courseCategories.map((category) => (
              <button
                key={category.id}
                className={`sidebar-link ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category.id)}
              >                <span className="link-text">{category.name}</span>
                <FaChevronRight className="arrow-icon" />
              </button>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="content-area">
          <div className="content-header">
            <div>
              <h2>{getActiveCategoryName()}</h2>
              <p>Select a course to view details and enrollment options</p>
            </div>
            <div className="filter-buttons">
              <button 
                className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`} 
                onClick={() => setActiveFilter('all')}
              >
                All Courses
              </button>
              <button 
                className={`filter-btn ${activeFilter === '3months' ? 'active' : ''}`} 
                onClick={() => setActiveFilter('3months')}
              >
                3 Months
              </button>
              <button 
                className={`filter-btn ${activeFilter === '6months' ? 'active' : ''}`} 
                onClick={() => setActiveFilter('6months')}
              >
                6 Months
              </button>
              <button 
                className={`filter-btn ${activeFilter === '9months' ? 'active' : ''}`} 
                onClick={() => setActiveFilter('9months')}
              >
                9 Months
              </button>
              <button 
                className={`filter-btn ${activeFilter === '1year' ? 'active' : ''}`} 
                onClick={() => setActiveFilter('1year')}
              >
                1 Year+
              </button>
              <button 
                className={`filter-btn ${activeFilter === 'popular' ? 'active' : ''}`} 
                onClick={() => setActiveFilter('popular')}
              >
                Popular
              </button>
            </div>
          </div>

          {/* Course List */}
          <div className={`course-list ${isAnimating ? 'fade-out' : 'fade-in'}`}>
            {getFilteredCourses().map((course) => (
              <div key={course.id} className="course-card">
                <div className="card-header">
                  <div className="course-icon-container">
                    {courseCategories.find(cat => cat.id === activeCategory)?.icon}
                  </div>
                  <div className="card-header-info">
                    <h3 className="card-title">{course.name}</h3>
                    <div className="course-badges">
                      <span className="badge badge-info">
                        <FaClock className="badge-icon" /> {course.duration}
                      </span>
                      <span className="badge badge-success">
                        {course.level}
                      </span>
                      {course.popular && (
                        <span className="badge badge-primary badge-pill">
                          Popular
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <p className="card-description">{course.description}</p>
                  <div className="card-actions">
                    <button className="action-btn view-btn">
                      <FaEye /> View Course
                    </button>
                    <button className="action-btn download-btn">
                      <FaDownload /> Download Brochure
                    </button>
                  </div>
                </div>
              </div>
            ))}
            
            {getFilteredCourses().length === 0 && (
              <div className="no-courses">
                <p>No courses match the selected filter. Try another filter option.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>
      )}

      <style jsx>{`
        /* Global styles */
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        /* Course Section Wrapper */
        .course-section-wrapper {
          position: relative;
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }

        /* Main container */
        .course-section-container {
          display: flex;
          height: 80vh;
          width: 100%;
          background-color: #000;
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgb(40, 189, 97);
          margin: 20px 0;
        }

        /* Mobile menu button */
        .mobile-menu-btn {
          display: none;
          align-items: center;
          background: #58A95B;
          color: white;
          border: none;
          padding: 10px 15px;
          border-radius: 8px;
          margin: 10px 0;
          cursor: pointer;
          font-weight: 500;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .mobile-menu-btn svg {
          margin-right: 8px;
        }

        /* Sidebar styles */
        .sidebar {
          width: 240px;
          min-width: 240px;
          background-color: #000;
          border-right: 1px solid #e9ecef;
          display: flex;
          flex-direction: column;
          height: 100%;
          box-shadow: 2px 0 10px rgba(0, 0, 0, 0.03);
          transition: transform 0.3s ease;
        }

        .sidebar-header {
          padding: 20px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e9ecef;
        }

        .sidebar-icon {
          font-size: 20px;
          color: #58A95B;
          margin-right: 1px;
        }

        .sidebar-header h3 {
          margin: 0;
          font-size: 18px;
          font-weight: bolder;
          color: #fff;
        }

        .close-sidebar {
          margin-left: auto;
          background: none;
          border: none;
          color:rgb(255, 83, 83);
          cursor: pointer;
          font-size: 16px;
        }

        .sidebar-links {
          overflow-y: auto;
          flex-grow: 1;
          padding: 10px 0;
        }

        .sidebar-link {
          display: flex;
          align-items: center;
          padding: 10px 15px;
          text-decoration: none;
          color:rgb(255, 255, 255);
          border: none;
          background: none;
          width: 100%;
          text-align: left;
          cursor: pointer;
          transition: background-color 0.2s;
          font-size: 14px;
        }

        .sidebar-link:hover {
          background-color: #f1f3f5;
          color: #4c84ff;
        }

        .sidebar-link.active {
          background-color:rgb(255, 255, 255);
          color:rgb(0, 71, 225);
          border-left: 3px solid #4c84ff;
        }

        .icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          color: #4c84ff;
          font-size: 14px;
        }

        .sidebar-link.active .icon-container {
          color: #4c84ff;
        }

        .link-text {
          flex-grow: 1;
          font-weight: 500;
        }

        .arrow-icon {
          font-size: 10px;
          margin-left: 6px;
          opacity: 0.5;
        }

        .sidebar-link.active .arrow-icon {
          opacity: 1;
        }

        /* Main content area */
        .content-area {
          flex-grow: 1;
          padding: 20px;
          overflow-y: auto;
          height: 100%;
          background-color: #fafbfc;
        }

        .content-header {
          margin-bottom: 20px;
        }

        .content-header h2 {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          color: #212529;
        }

        .content-header p {
          color: #6c757d;
          margin: 5px 0 15px;
          font-size: 13px;
        }

        .filter-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 15px;
        }

        .filter-btn {
          background-color:rgb(190, 190, 190);
          border: 1px solid #e9ecef;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          color: #495057;
          cursor: pointer;
          transition: all 0.2s;
        }

        .filter-btn:hover {
          background-color: #e9ecef;
        }

        .filter-btn.active {
          background-color:#58A95B;
          color: white;
          border-color:rgb(0, 0, 0);
        }

        /* Course list */
        .course-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
          transition: opacity 0.3s;
        }

        .fade-out {
          opacity: 0;
        }

        .fade-in {
          opacity: 1;
        }

        /* Course cards */
        .course-card {
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.course-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.08);
}

.card-header {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #f1f3f5;
}

.course-icon-container {
  background-color: #f1f4ff;
  color: #4c84ff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 18px;
}

.card-header-info {
  flex-grow: 1;
}

.card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.course-badges {
  display: flex;
  gap: 6px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
}

.badge-icon {
  margin-right: 4px;
  font-size: 10px;
}

.badge-info {
  background-color: #e9f5fe;
  color: #0d6efd;
}

.badge-success {
  background-color: #e3faef;
  color: #198754;
}

.badge-primary {
  background-color: #e9f0ff;
  color: #4c84ff;
}

.badge-pill {
  border-radius: 20px;
}

.card-body {
  padding: 15px;
}

.card-description {
  margin: 0;
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 15px;
  line-height: 1.5;
}

.card-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s;
}

.action-btn svg {
  margin-right: 6px;
  font-size: 11px;
}

.view-btn {
  background-color: #4c84ff;
  color: white;
}

.view-btn:hover {
  background-color: #3a6ccc;
}

.download-btn {
  background-color: #f1f3f5;
  color: #495057;
}

.download-btn:hover {
  background-color: #e9ecef;
}

.no-courses {
  background-color: #ffffff;
  padding: 30px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
}

.no-courses p {
  color: #6c757d;
  font-size: 14px;
}

/* Overlay for mobile sidebar */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Mobile responsive styles */
@media (max-width: 767px) {
  .course-section-container {
    height: auto;
    min-height: 60vh;
  }
  
  .mobile-menu-btn {
    display: flex;
  }
  
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1000;
    transform: translateX(-100%);
    width: 80%;
    max-width: 300px;
  }
  
  .sidebar.open {
    transform: translateX(0);
  }
  
  .content-header {
    flex-direction: column;
  }
  
  .filter-buttons {
    justify-content: flex-start;
    margin-top: 15px;
  }
  
  .card-actions {
    flex-direction: column;
  }
  
  .action-btn {
    width: 100%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .course-card {
    flex: 0 0 calc(50% - 10px);
  }
}

@media (min-width: 992px) {
  .course-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }
}`}
</style>
</div>
</div>
  )
}
export default CourseSectionPage;